import { Box, Text, TextProps } from 'grommet';
import { ReactNode } from 'react';
import { Divider } from '../Divider';

export type RightInfoItemProps = { title: ReactNode; value: ReactNode; textSize?: TextProps['size'] };

export const RightInfoItem = ({ title, value, textSize = 'medium' }: RightInfoItemProps) => (
  <Box gap="xsmall">
    <Text size="small" weight="bold">
      {title}
    </Text>
    <Divider height="0.5px" />
    {typeof value === 'string' ? <Text size={textSize}>{value}</Text> : value}
  </Box>
);
